import styled from '@emotion/styled';
import BaseButton from './BaseButton';
import { changeColorShade } from '@dnhb/node_package';

const PrimaryButton = styled(BaseButton)`
  color: ${props => props.theme.secondaryFontColor};
  border-color: ${props => props.theme.highlightColor};
  background: ${props => props.theme.highlightColor};

  &:hover:not(:disabled) {
    background: ${props => changeColorShade(props.theme.highlightColor)};
  }
`;

export default PrimaryButton;
